{
  "id": "japan",
  "name": "Japan",
  "viewBox": {
    "x": 77.56,
    "y": 105.25,
    "width": 750.88,
    "height": 845
  },
  "backdropColor": {
    "light": "#e9c9b4",
    "dark": "#3a2620",
    "topBar": true
  },
  "selectionInnerGlow": true,
  "gameLayout": {
    "topBarOverlap": 0.9,
    "playerBarPosition": "center"
  },
  "edgeConfig": {
    "internalBorderWidth": 1.2,
    "regionBorderWidth": 5.6,
    "bridgeStrokeWidth": 0
  },
  "regions": [
    {
      "id": "tohoku",
      "name": "Tōhoku",
      "bonus": 4,
      "territoryIds": [
        "jp-00",
        "jp-01",
        "jp-02",
        "jp-03",
        "jp-04",
        "jp-05",
        "jp-06"
      ],
      "color": "#039BE5",
      "shape": "M 624.2 266.4 L 626.9 267.5 L 628.7 271.1 L 631.8 271.8 L 634.9 277.1 L 635.6 284.4 L 632.1 289.9 L 631.7 293.1 L 631.6 294.1 L 631.4 296.2 L 632.2 299.2 L 632.5 300.2 L 632.8 301.2 L 637.7 303.1 L 638.5 303.0 L 640.4 299.2 L 646.1 296.8 L 646.1 292.6 L 646.2 290.6 L 648.0 289.6 L 650.8 288.0 L 652.6 284.4 L 654.5 284.6 L 654.5 286.7 L 654.5 287.8 L 655.1 287.3 L 655.8 286.5 L 656.6 285.8 L 657.6 286.3 L 658.5 286.7 L 659.5 287.1 L 660.4 287.5 L 661.4 288.0 L 662.4 288.4 L 663.3 288.5 L 664.4 288.2 L 665.4 288.0 L 666.2 287.4 L 667.1 286.8 L 667.9 286.1 L 668.7 285.4 L 669.5 284.7 L 669.6 284.0 L 669.0 283.1 L 668.4 282.3 L 667.4 281.8 L 666.5 281.3 L 665.5 280.8 L 664.6 280.4 L 663.7 279.9 L 662.8 279.4 L 662.1 278.6 L 661.4 277.8 L 660.7 277.0 L 660.1 276.2 L 659.4 275.4 L 658.7 274.5 L 658.1 273.7 L 657.4 272.9 L 656.7 272.1 L 656.0 271.3 L 655.1 271.2 L 654.1 271.3 L 653.0 271.4 L 652.0 271.5 L 650.9 271.6 L 649.9 271.7 L 648.8 271.8 L 648.0 271.2 L 647.1 270.6 L 646.2 270.0 L 645.3 269.5 L 644.5 268.9 L 643.6 268.3 L 642.7 267.7 L 641.8 267.1 L 641.0 266.5 L 640.4 265.8 L 640.2 264.7 L 640.0 263.7 L 639.8 262.7 L 641.8 256.7 L 646.1 250.8 L 651.3 250.8 L 653.4 251.1 L 658.1 255.2 L 658.8 256.0 L 660.1 259.9 L 661.2 260.1 L 663.2 260.5 L 662.9 260.8 L 660.9 261.3 L 663.5 262.7 L 673.9 252.4 L 678.6 250.0 L 679.5 249.5 L 682.3 248.1 L 685.1 246.7 L 682.6 248.0 L 691.7 249.5 L 692.5 250.0 L 693.4 250.6 L 698.7 254.0 L 699.6 254.6 L 704.0 257.4 L 704.9 258.0 L 711.1 262.0 L 727.0 267.5 L 730.2 270.1 L 731.0 270.8 L 734.2 273.5 L 735.0 274.2 L 736.6 275.6 L 737.2 275.6 L 738.5 269.5 L 738.5 260.0 L 738.5 259.0 L 738.9 258.0 L 741.9 251.3 L 742.9 249.5 L 746.1 244.0 L 748.8 240.8 L 749.5 240.0 L 755.7 232.9 L 757.5 231.8 L 758.4 231.3 L 761.2 229.8 L 762.1 229.3 L 766.7 227.1 L 769.7 228.2 L 770.7 228.6 L 772.7 229.1 L 782.1 228.4 L 780.6 226.9 L 782.9 223.4 L 783.6 223.0 L 784.5 223.4 L 784.2 225.2 L 785.9 226.3 L 786.9 226.3 L 789.0 226.2 L 792.5 222.4 L 794.0 218.6 L 796.1 218.2 L 797.1 218.0 L 799.2 217.7 L 800.2 217.5 L 805.4 216.6 L 806.4 211.6 L 814.0 206.1 L 808.9 206.7 L 808.1 207.2 L 804.3 212.2 L 800.4 211.2 L 797.4 208.3 L 796.3 206.6 L 796.0 205.6 L 793.8 198.5 L 794.6 198.3 L 795.92 198.3 L 791.6 196.8 L 791.0 195.9 L 788.9 192.4 L 788.9 188.2 L 789.0 186.1 L 796.5 169.9 L 796.3 168.9 L 795.9 167.9 L 795.1 166.2 L 779.8 185.0 L 768.3 185.0 L 766.3 184.8 L 762.2 181.4 L 761.2 178.6 L 741.8 174.4 L 721.3 161.6 L 710.5 150.1 L 705.0 141.2 L 692.2 127.3 L 691.5 126.5 L 686.5 121.5 L 682.7 126.6 L 681.9 126.9 L 680.8 126.9 L 678.8 126.7 L 677.7 124.9 L 678.2 128.8 L 676.8 133.8 L 676.5 134.8 L 676.2 135.8 L 677.7 139.7 L 678.1 140.7 L 680.2 145.5 L 680.6 146.5 L 681.8 149.4 L 683.8 160.8 L 683.5 165.0 L 683.4 166.0 L 683.1 169.1 L 680.4 174.8 L 680.6 179.0 L 680.6 180.0 L 681.1 190.5 L 678.5 193.8 L 674.8 195.8 L 673.9 196.3 L 672.4 197.6 L 671.3 200.5 L 672.8 207.7 L 673.0 208.7 L 674.3 214.9 L 674.5 215.9 L 674.4 217.9 L 671.0 224.3 L 667.0 225.6 L 666.0 225.3 L 665.0 225.0 L 662.2 224.0 L 661.9 222.2 L 660.9 222.5 L 655.0 224.0 L 645.9 216.9 L 645.0 216.7 L 643.1 217.5 L 642.1 217.9 L 640.5 218.9 L 640.5 222.1 L 640.8 224.1 L 644.4 229.2 L 645.0 230.1 L 646.7 232.7 L 642.6 236.0 L 640.9 239.8 L 640.5 240.8 L 639.5 242.6 L 638.5 243.0 L 636.6 240.7 L 636.0 240.8 L 631.8 246.7 L 626.7 248.0 L 625.1 250.5 L 625.4 253.7 L 625.5 254.7 L 625.8 257.8 L 623.0 263.5 L 624.2 266.4 Z M 691.0 349.0 L 687.0 350.0 L 683.0 339.0 L 680.0 325.0 L 683.0 294.0 L 674.0 299.0 L 657.0 287.0 L 651.0 313.0 L 665.0 310.0 L 671.0 304.0 L 675.0 311.0 L 671.0 327.0 L 668.0 329.0 L 657.0 321.0 L 655.0 325.0 L 656.0 329.0 L 650.0 332.0 L 647.0 325.0 L 645.0 310.0 L 641.0 308.0 L 637.0 311.0 L 631.0 306.0 L 630.0 313.0 L 627.0 314.0 L 630.0 319.0 L 628.0 335.0 L 621.0 339.0 L 616.0 339.0 L 609.0 347.0 L 613.0 351.0 L 613.0 358.0 L 618.0 364.0 L 618.0 372.0 L 614.0 380.0 L 608.0 388.0 L 602.0 386.0 L 605.0 394.0 L 613.0 392.0 L 620.0 399.0 L 619.0 422.0 L 614.0 431.0 L 612.0 440.0 L 610.0 454.0 L 597.0 476.0 L 606.0 479.0 L 605.0 486.0 L 615.0 492.0 L 613.0 496.0 L 604.0 500.0 L 605.0 507.0 L 602.0 516.0 L 604.0 520.0 L 607.0 522.0 L 598.0 533.0 L 600.0 541.0 L 592.0 541.0 L 591.0 545.0 L 582.0 545.0 L 581.0 548.0 L 583.0 552.0 L 579.0 559.0 L 584.0 563.0 L 583.0 577.0 L 591.0 579.0 L 616.0 563.0 L 628.0 566.0 L 634.0 571.0 L 635.0 577.0 L 645.0 585.0 L 651.0 580.0 L 651.0 575.0 L 661.0 580.0 L 670.0 573.0 L 672.0 556.0 L 672.0 530.0 L 666.0 515.0 L 666.0 502.0 L 671.0 492.0 L 669.0 492.0 L 673.0 490.0 L 670.0 489.0 L 672.0 485.0 L 689.0 483.0 L 691.0 485.0 L 689.0 486.0 L 691.0 486.0 L 690.0 488.0 L 694.0 491.0 L 695.0 487.0 L 692.0 484.0 L 695.0 483.0 L 691.0 483.0 L 690.0 480.0 L 693.0 480.0 L 691.0 475.0 L 694.0 477.0 L 694.0 474.0 L 690.0 474.0 L 694.0 468.0 L 689.0 466.0 L 693.0 463.0 L 695.0 465.0 L 693.0 460.0 L 697.0 456.0 L 695.0 451.0 L 700.0 454.0 L 698.0 447.0 L 700.0 445.0 L 701.0 449.0 L 701.0 445.0 L 703.0 445.0 L 702.72 443.88 L 708.0 443.0 L 706.0 441.0 L 709.0 441.0 L 706.0 438.0 L 711.0 438.0 L 707.0 436.0 L 713.0 429.0 L 709.0 429.0 L 711.0 428.0 L 709.0 425.0 L 714.0 422.0 L 710.0 423.0 L 712.0 422.0 L 713.0 418.0 L 716.0 418.0 L 717.0 414.0 L 713.0 417.0 L 712.0 415.0 L 717.0 410.0 L 715.0 408.0 L 715.0 403.0 L 711.0 408.0 L 713.0 397.0 L 711.0 383.0 L 704.0 378.0 L 706.0 373.0 L 702.0 370.0 L 703.0 366.0 L 696.0 354.0 L 691.0 349.0 Z",
      "bonusAnchor": {
        "x": 723.95,
        "y": 323.46
      }
    },
    {
      "id": "kanto",
      "name": "Kantō",
      "bonus": 5,
      "territoryIds": [
        "jp-07",
        "jp-08",
        "jp-09",
        "jp-10",
        "jp-11",
        "jp-13",
        "jp-18"
      ],
      "color": "#F57C00",
      "shape": "M 628.0 566.0 L 616.0 563.0 L 591.0 579.0 L 583.0 577.0 L 576.0 570.0 L 574.0 574.0 L 570.0 575.0 L 571.0 580.0 L 568.0 581.0 L 568.0 584.0 L 556.0 590.0 L 547.0 593.0 L 548.0 595.0 L 543.0 599.0 L 542.0 606.0 L 545.0 611.0 L 554.0 611.0 L 555.0 617.0 L 552.0 619.0 L 554.0 626.0 L 551.0 626.0 L 554.0 629.0 L 554.0 635.0 L 558.0 637.0 L 559.0 642.0 L 556.0 645.0 L 552.0 641.0 L 546.0 643.0 L 540.0 638.0 L 531.0 649.0 L 534.0 652.0 L 531.0 654.0 L 533.0 659.0 L 535.0 667.0 L 534.0 678.0 L 540.0 679.0 L 544.0 688.0 L 549.0 686.0 L 548.0 679.0 L 551.0 671.0 L 556.0 677.0 L 568.0 674.0 L 573.0 674.0 L 572.0 686.0 L 579.0 690.0 L 581.0 690.0 L 580.0 684.0 L 583.0 681.0 L 595.0 678.0 L 602.0 680.0 L 605.0 685.0 L 604.0 689.0 L 608.0 689.0 L 606.0 687.0 L 611.0 682.0 L 605.0 680.0 L 605.0 672.0 L 608.0 673.0 L 605.0 669.0 L 609.0 669.0 L 613.0 665.0 L 613.0 662.0 L 611.0 657.0 L 617.0 658.0 L 618.0 659.0 L 623.0 655.0 L 630.0 662.0 L 625.0 669.0 L 619.0 671.0 L 619.0 675.0 L 616.0 674.0 L 613.0 678.0 L 617.0 683.0 L 615.0 687.0 L 616.0 693.0 L 614.0 696.0 L 617.0 698.0 L 612.0 700.0 L 619.0 704.0 L 630.0 690.0 L 643.0 686.0 L 646.0 664.0 L 657.0 654.0 L 667.0 653.0 L 666.0 650.0 L 659.0 637.0 L 658.0 642.0 L 656.0 639.0 L 658.0 636.0 L 653.0 628.0 L 651.0 617.0 L 654.0 611.0 L 653.0 604.0 L 661.0 580.0 L 651.0 575.0 L 651.0 580.0 L 645.0 585.0 L 635.0 577.0 L 634.0 571.0 L 628.0 566.0 Z",
      "bonusAnchor": {
        "x": 688.19,
        "y": 635.55
      }
    },
    {
      "id": "chubu",
      "name": "Chūbu",
      "bonus": 6,
      "territoryIds": [
        "jp-14",
        "jp-15",
        "jp-16",
        "jp-17",
        "jp-19",
        "jp-20",
        "jp-21",
        "jp-22"
      ],
      "shape": "M 568.0 581.0 L 571.0 580.0 L 570.0 575.0 L 574.0 574.0 L 576.0 570.0 L 583.0 577.0 L 584.0 563.0 L 579.0 559.0 L 583.0 552.0 L 581.0 548.0 L 582.0 545.0 L 591.0 545.0 L 592.0 541.0 L 600.0 541.0 L 598.0 533.0 L 607.0 522.0 L 604.0 520.0 L 602.0 516.0 L 605.0 507.0 L 604.0 500.0 L 613.0 496.0 L 615.0 492.0 L 605.0 486.0 L 606.0 479.0 L 597.0 476.0 L 589.0 505.0 L 582.26 510.78 L 582.0 510.0 L 563.0 523.0 L 558.0 536.0 L 548.0 551.0 L 533.0 563.0 L 526.0 563.0 L 517.0 570.0 L 503.0 575.0 L 493.0 578.0 L 491.0 586.0 L 483.0 590.0 L 471.0 583.0 L 474.0 576.0 L 474.0 567.0 L 471.0 571.0 L 465.0 569.0 L 467.0 560.0 L 470.0 559.0 L 472.0 562.0 L 479.0 555.0 L 483.0 556.0 L 484.0 547.0 L 490.0 546.0 L 489.0 542.0 L 485.0 541.0 L 460.0 551.0 L 455.0 564.0 L 458.0 565.0 L 458.0 570.0 L 460.0 574.0 L 459.0 585.0 L 447.0 603.0 L 433.0 617.0 L 427.0 620.0 L 427.0 624.0 L 418.0 637.0 L 425.0 650.0 L 424.0 657.0 L 421.0 656.0 L 421.0 650.0 L 418.0 653.0 L 419.0 659.0 L 411.0 658.0 L 413.0 661.0 L 410.0 662.0 L 411.0 665.0 L 405.0 662.0 L 406.0 665.0 L 408.0 665.0 L 405.0 668.0 L 399.0 667.0 L 403.0 664.0 L 396.0 667.0 L 394.0 663.0 L 392.0 668.0 L 396.0 674.0 L 408.0 676.0 L 410.0 672.0 L 414.0 673.0 L 417.0 666.0 L 420.0 668.0 L 425.0 665.0 L 426.0 662.0 L 429.0 663.0 L 428.0 655.0 L 434.0 657.0 L 436.0 664.0 L 439.0 664.0 L 442.0 671.0 L 442.0 674.0 L 439.0 683.0 L 441.0 685.0 L 447.0 683.0 L 454.0 690.0 L 459.0 697.0 L 465.0 694.0 L 461.0 701.0 L 461.0 706.0 L 464.0 709.0 L 462.0 714.0 L 467.0 717.0 L 469.0 717.0 L 466.0 713.0 L 470.0 702.0 L 468.0 710.0 L 472.0 713.0 L 480.0 714.0 L 482.0 710.0 L 488.0 713.0 L 489.0 716.0 L 486.0 719.0 L 485.0 716.0 L 476.0 722.0 L 474.0 720.0 L 471.0 725.0 L 495.0 719.0 L 520.0 720.0 L 533.0 724.0 L 532.0 720.0 L 537.0 713.0 L 540.0 704.0 L 548.0 700.0 L 547.0 697.0 L 550.0 693.0 L 557.0 690.0 L 568.0 696.0 L 562.0 697.0 L 561.0 701.0 L 562.0 704.0 L 560.0 718.0 L 565.0 724.0 L 573.0 720.0 L 573.0 715.0 L 580.0 705.0 L 581.0 701.0 L 576.0 695.0 L 579.0 690.0 L 572.0 686.0 L 573.0 674.0 L 568.0 674.0 L 556.0 677.0 L 551.0 671.0 L 548.0 679.0 L 549.0 686.0 L 544.0 688.0 L 540.0 679.0 L 534.0 678.0 L 535.0 667.0 L 533.0 659.0 L 531.0 654.0 L 534.0 652.0 L 531.0 649.0 L 540.0 638.0 L 546.0 643.0 L 552.0 641.0 L 556.0 645.0 L 559.0 642.0 L 558.0 637.0 L 554.0 635.0 L 554.0 629.0 L 551.0 626.0 L 554.0 626.0 L 552.0 619.0 L 555.0 617.0 L 554.0 611.0 L 545.0 611.0 L 542.0 606.0 L 543.0 599.0 L 548.0 595.0 L 547.0 593.0 L 556.0 590.0 L 568.0 584.0 L 568.0 581.0 Z",
      "color": "#388E3C",
      "bonusAnchor": {
        "x": 513.76,
        "y": 528.13
      }
    },
    {
      "id": "kansai",
      "name": "Kansai",
      "bonus": 4,
      "territoryIds": [
        "jp-23",
        "jp-24",
        "jp-25",
        "jp-26",
        "jp-28",
        "jp-29"
      ],
      "color": "#A08000",
      "shape": "M 439.0 683.0 L 442.0 674.0 L 442.0 671.0 L 439.0 664.0 L 436.0 664.0 L 434.0 657.0 L 428.0 655.0 L 429.0 663.0 L 426.0 662.0 L 425.0 665.0 L 420.0 668.0 L 417.0 666.0 L 414.0 673.0 L 410.0 672.0 L 408.0 676.0 L 396.0 674.0 L 392.0 668.0 L 394.0 663.0 L 393.0 660.0 L 386.0 663.0 L 389.0 668.0 L 387.0 667.0 L 385.0 669.0 L 386.0 665.0 L 381.0 664.0 L 382.0 660.0 L 379.0 664.0 L 377.0 662.0 L 385.0 656.0 L 381.0 649.0 L 364.0 656.0 L 365.0 659.0 L 363.0 656.0 L 362.0 660.0 L 365.0 665.0 L 371.0 663.0 L 371.0 665.0 L 371.0 672.0 L 365.0 671.0 L 365.0 677.0 L 372.0 682.0 L 377.0 681.0 L 379.0 687.0 L 388.0 689.0 L 387.0 695.0 L 385.0 695.0 L 386.0 700.0 L 392.0 702.0 L 389.0 703.0 L 391.0 714.0 L 388.0 716.0 L 391.0 725.0 L 388.0 722.0 L 385.0 732.0 L 378.0 738.0 L 372.0 740.0 L 370.0 743.0 L 378.0 750.0 L 373.0 751.0 L 374.0 753.0 L 371.0 755.0 L 375.0 758.0 L 370.0 761.0 L 372.0 762.0 L 369.0 767.0 L 373.0 767.0 L 378.0 773.0 L 387.0 777.0 L 383.0 780.0 L 389.0 788.0 L 405.0 793.0 L 405.0 795.0 L 406.0 795.0 L 407.0 792.0 L 416.0 787.0 L 414.0 783.0 L 418.0 778.0 L 423.0 768.0 L 430.0 764.0 L 429.0 761.0 L 432.0 763.0 L 431.0 760.0 L 433.0 759.0 L 429.0 756.0 L 432.0 753.0 L 431.0 755.0 L 434.0 755.0 L 433.0 751.0 L 435.0 748.0 L 443.0 745.0 L 445.0 747.0 L 445.0 744.0 L 447.0 745.0 L 449.0 743.0 L 450.0 745.0 L 453.0 740.0 L 456.0 740.0 L 454.0 743.0 L 460.0 743.0 L 460.0 741.0 L 463.0 743.0 L 462.0 744.0 L 465.0 744.0 L 466.0 738.0 L 466.0 733.0 L 464.0 735.0 L 462.0 730.0 L 446.0 723.0 L 446.0 715.0 L 453.0 703.0 L 453.0 699.0 L 459.0 697.0 L 454.0 690.0 L 447.0 683.0 L 441.0 685.0 L 439.0 683.0 Z",
      "bonusAnchor": {
        "x": 455.03,
        "y": 777.56
      }
    },
    {
      "id": "chugoku",
      "name": "Chūgoku",
      "bonus": 4,
      "territoryIds": [
        "jp-27",
        "jp-30",
        "jp-31",
        "jp-32",
        "jp-33",
        "jp-34"
      ],
      "color": "#E91E63",
      "shape": "M 335.0 711.0 L 338.0 713.0 L 340.0 708.0 L 341.0 711.0 L 355.0 711.0 L 370.0 720.0 L 383.0 715.0 L 388.0 716.0 L 391.0 714.0 L 389.0 703.0 L 392.0 702.0 L 386.0 700.0 L 385.0 695.0 L 387.0 695.0 L 388.0 689.0 L 379.0 687.0 L 377.0 681.0 L 372.0 682.0 L 365.0 677.0 L 365.0 671.0 L 371.0 672.0 L 371.0 665.0 L 371.0 663.0 L 365.0 665.0 L 362.0 660.0 L 363.0 656.0 L 346.0 654.0 L 337.0 657.0 L 328.0 662.0 L 307.0 663.0 L 296.0 661.0 L 288.0 665.0 L 282.0 663.0 L 280.0 659.0 L 283.0 658.0 L 275.0 658.0 L 272.0 655.0 L 266.0 660.0 L 248.0 665.0 L 250.0 668.0 L 248.0 674.0 L 237.0 679.0 L 231.0 687.0 L 220.0 693.0 L 206.0 707.0 L 198.0 709.0 L 196.0 711.0 L 193.0 710.0 L 182.0 721.0 L 183.0 724.0 L 177.0 726.0 L 169.0 726.0 L 168.0 723.0 L 160.0 721.0 L 158.0 724.0 L 163.0 726.0 L 156.0 726.0 L 154.0 730.0 L 157.0 735.0 L 153.0 741.0 L 155.0 745.0 L 155.0 752.0 L 162.0 745.0 L 167.0 749.0 L 169.0 754.0 L 171.0 752.0 L 173.0 754.0 L 178.0 752.0 L 180.0 747.0 L 180.0 751.0 L 182.0 749.0 L 182.0 751.0 L 184.0 748.0 L 188.0 751.0 L 198.0 747.0 L 202.0 750.0 L 200.0 753.0 L 204.0 751.0 L 209.0 757.0 L 214.0 757.0 L 218.0 763.0 L 217.0 756.0 L 222.0 753.0 L 222.0 745.0 L 224.0 745.0 L 225.0 740.0 L 224.0 737.0 L 231.0 731.0 L 239.0 731.0 L 238.0 733.0 L 241.0 739.0 L 240.0 742.0 L 243.0 740.0 L 245.0 742.0 L 251.0 739.0 L 253.0 735.0 L 266.0 735.0 L 268.0 730.0 L 277.0 728.0 L 277.0 731.0 L 283.0 733.0 L 285.0 729.0 L 287.0 729.0 L 284.0 726.0 L 287.0 728.0 L 287.0 726.0 L 291.0 728.0 L 289.0 724.0 L 295.0 727.0 L 299.0 723.0 L 302.0 728.0 L 302.0 724.0 L 305.0 730.0 L 307.0 727.0 L 312.0 729.0 L 314.0 725.0 L 316.0 726.0 L 318.0 722.0 L 313.0 720.0 L 322.0 721.0 L 329.0 714.0 L 326.0 712.0 L 333.0 713.0 L 335.0 711.0 Z",
      "bonusAnchor": {
        "x": 268.48,
        "y": 628.9
      }
    },
    {
      "id": "shikoku",
      "name": "Shikoku",
      "bonus": 3,
      "territoryIds": [
        "jp-35",
        "jp-36",
        "jp-37",
        "jp-38"
      ],
      "color": "#00E5CC",
      "shape": "M 329.0 737.0 L 326.0 735.0 L 324.0 737.0 L 323.0 733.0 L 319.0 736.0 L 312.0 733.0 L 298.0 743.0 L 292.0 740.0 L 297.0 745.0 L 294.0 754.0 L 289.0 758.0 L 279.0 756.0 L 269.0 760.0 L 260.0 746.0 L 258.0 747.0 L 259.0 751.0 L 251.0 755.0 L 244.0 773.0 L 210.0 793.0 L 217.0 792.0 L 225.0 786.0 L 231.0 787.0 L 229.0 792.0 L 231.0 794.0 L 228.0 796.0 L 236.0 796.0 L 234.0 799.0 L 237.0 799.0 L 238.0 802.0 L 234.0 806.0 L 232.86 805.14 L 231.0 807.0 L 235.0 808.0 L 231.0 808.0 L 233.0 812.0 L 231.0 813.0 L 237.0 818.0 L 233.0 817.0 L 232.0 822.0 L 235.0 822.0 L 234.0 819.0 L 242.0 821.0 L 245.0 821.0 L 245.0 824.0 L 242.0 825.0 L 240.0 831.0 L 244.0 829.0 L 249.0 833.0 L 256.0 830.0 L 260.0 835.0 L 257.0 828.0 L 260.0 825.0 L 260.0 817.0 L 265.0 816.0 L 269.0 808.0 L 272.0 808.0 L 274.0 802.0 L 273.0 798.0 L 276.0 793.0 L 278.0 796.0 L 279.0 793.0 L 285.0 792.0 L 279.0 792.0 L 291.0 788.0 L 300.0 786.0 L 310.0 789.0 L 322.0 805.0 L 329.0 786.0 L 334.0 780.0 L 353.0 769.0 L 347.0 768.0 L 351.0 763.0 L 344.0 756.0 L 348.0 747.0 L 345.0 746.0 L 345.0 744.0 L 338.0 745.0 L 329.0 740.0 L 329.0 737.0 Z",
      "bonusAnchor": {
        "x": 300.64,
        "y": 823.91
      }
    },
    {
      "id": "kyushu",
      "name": "Kyūshū",
      "bonus": 4,
      "territoryIds": [
        "jp-39",
        "jp-40",
        "jp-42",
        "jp-43",
        "jp-44",
        "jp-45"
      ],
      "color": "#7E57C2",
      "shape": "M 134.0 899.0 L 134.0 905.0 L 139.0 913.0 L 135.0 926.0 L 130.0 929.0 L 130.0 934.0 L 146.0 926.0 L 150.0 921.0 L 156.0 918.0 L 153.0 918.0 L 155.0 915.0 L 150.0 912.0 L 155.0 906.0 L 158.0 907.0 L 163.0 912.0 L 168.0 914.0 L 170.0 902.0 L 175.0 897.0 L 178.0 874.0 L 184.0 857.0 L 189.0 849.0 L 187.0 848.0 L 188.0 846.0 L 192.0 845.0 L 189.0 844.0 L 190.0 840.0 L 201.0 830.0 L 201.0 826.0 L 208.0 825.0 L 204.0 824.0 L 208.0 821.0 L 206.0 819.0 L 212.0 819.0 L 202.0 815.0 L 204.0 811.0 L 209.0 811.0 L 208.0 808.0 L 203.0 810.0 L 200.0 808.0 L 203.0 806.0 L 198.0 806.0 L 204.0 797.0 L 187.0 798.0 L 183.0 796.0 L 183.0 792.0 L 191.0 790.0 L 190.0 787.0 L 194.0 788.0 L 196.0 780.0 L 194.0 774.0 L 185.0 770.0 L 180.0 777.0 L 168.0 773.0 L 163.0 772.0 L 158.0 762.0 L 159.0 761.0 L 157.0 759.0 L 161.0 751.0 L 154.0 755.0 L 150.0 753.0 L 149.0 756.0 L 146.0 755.0 L 149.0 752.0 L 143.0 751.0 L 142.0 754.0 L 132.0 755.0 L 131.0 763.0 L 127.0 766.0 L 122.0 765.0 L 125.0 768.0 L 129.0 766.0 L 127.0 771.0 L 120.0 772.0 L 117.0 766.0 L 111.0 771.0 L 114.0 774.0 L 108.0 778.0 L 104.0 778.0 L 104.0 774.0 L 99.0 774.0 L 98.0 772.0 L 98.0 778.0 L 96.0 776.0 L 94.0 778.0 L 99.0 781.0 L 96.0 785.0 L 98.0 789.0 L 94.0 785.0 L 92.0 788.0 L 95.0 794.0 L 101.0 796.0 L 100.0 801.0 L 107.0 808.0 L 114.0 810.0 L 112.0 800.0 L 117.0 795.0 L 123.0 800.0 L 125.0 803.0 L 125.0 808.0 L 126.0 814.0 L 135.0 822.0 L 134.0 827.0 L 126.0 833.0 L 136.0 832.0 L 130.0 838.0 L 131.0 840.0 L 129.0 839.0 L 131.0 844.0 L 119.0 860.0 L 115.0 864.0 L 112.0 862.0 L 108.0 864.0 L 110.0 875.0 L 107.0 882.0 L 112.0 887.0 L 115.0 895.0 L 111.0 906.0 L 102.0 905.0 L 107.0 910.0 L 105.0 911.0 L 108.0 913.0 L 107.0 916.0 L 120.0 917.0 L 123.0 923.0 L 129.0 922.0 L 131.0 917.0 L 126.0 914.0 L 124.0 903.0 L 130.0 890.0 L 134.0 888.0 L 141.0 893.0 L 137.0 899.0 L 134.0 899.0 Z M 134.0 899.0 L 133.0 895.0 L 128.0 897.0 L 134.0 899.0 Z",
      "bonusAnchor": {
        "x": 102.26,
        "y": 836.44
      }
    }
  ],
  "territories": [
    {
      "id": "jp-00",
      "name": "Hokkaido",
      "regionId": "tohoku",
      "adjacencies": [
        "jp-01"
      ],
      "shape": "M 625.5 254.7 L 625.4 253.7 L 625.1 250.5 L 626.7 248 L 631.8 246.7 L 636 240.8 L 636.6 240.7 L 638.5 243 L 639.5 242.6 L 640.5 240.8 L 640.9 239.8 L 642.6 236 L 646.7 232.7 L 645 230.1 L 644.4 229.2 L 640.8 224.1 L 640.5 222.1 L 640.5 218.9 L 642.1 217.9 L 643.1 217.5 L 645 216.7 L 645.9 216.9 L 655 224 L 660.9 222.5 L 661.9 222.2 L 662.2 224 L 665 225 L 666 225.3 L 667 225.6 L 671 224.3 L 674.4 217.9 L 674.5 215.9 L 674.3 214.9 L 673 208.7 L 672.8 207.7 L 671.3 200.5 L 672.4 197.6 L 673.9 196.3 L 674.8 195.8 L 678.5 193.8 L 681.1 190.5 L 680.6 180 L 680.6 179 L 680.4 174.8 L 683.1 169.1 L 683.4 166 L 683.5 165 L 683.8 160.8 L 681.8 149.4 L 680.6 146.5 L 680.2 145.5 L 678.1 140.7 L 677.7 139.7 L 676.2 135.8 L 676.5 134.8 L 676.8 133.8 L 678.2 128.8 L 677.7 124.9 L 678.8 126.7 L 680.8 126.9 L 681.9 126.9 L 682.7 126.6 L 686.5 121.5 L 691.5 126.5 L 692.2 127.3 L 705 141.2 L 710.5 150.1 L 721.3 161.6 L 741.8 174.4 L 761.2 178.6 L 762.2 181.4 L 766.3 184.8 L 768.3 185 L 779.8 185 L 795.1 166.2 L 795.9 167.9 L 796.3 168.9 L 796.5 169.9 L 789 186.1 L 788.9 188.2 L 788.9 192.4 L 791 195.9 L 791.6 196.8 L 796.5 198.5 L 797.5 198.9 L 797.6 199.4 L 796.8 200.1 L 797.7 198.3 L 794.6 198.3 L 793.8 198.5 L 796 205.6 L 796.3 206.6 L 797.4 208.3 L 800.4 211.2 L 804.3 212.2 L 808.1 207.2 L 808.9 206.7 L 814 206.1 L 806.4 211.6 L 805.4 216.6 L 800.2 217.5 L 799.2 217.7 L 797.1 218 L 796.1 218.2 L 794 218.6 L 792.5 222.4 L 789 226.2 L 786.9 226.3 L 785.9 226.3 L 784.2 225.2 L 784.5 223.4 L 783.6 223 L 782.9 223.4 L 780.6 226.9 L 782.1 228.4 L 772.7 229.1 L 770.7 228.6 L 769.7 228.2 L 766.7 227.1 L 762.1 229.3 L 761.2 229.8 L 758.4 231.3 L 757.5 231.8 L 755.7 232.9 L 749.5 240 L 748.8 240.8 L 746.1 244 L 742.9 249.5 L 741.9 251.3 L 738.9 258 L 738.5 259 L 738.5 260 L 738.5 269.5 L 737.2 275.6 L 736.6 275.6 L 735 274.2 L 734.2 273.5 L 731 270.8 L 730.2 270.1 L 727 267.5 L 711.1 262 L 704.9 258 L 704 257.4 L 699.6 254.6 L 698.7 254 L 693.4 250.6 L 692.5 250 L 691.7 249.5 L 682.6 248 L 685.1 246.7 L 682.3 248.1 L 679.5 249.5 L 678.6 250 L 673.9 252.4 L 663.5 262.7 L 660.9 261.3 L 662.9 260.8 L 663.2 260.5 L 661.2 260.1 L 660.1 259.9 L 658.8 256 L 658.1 255.2 L 653.4 251.1 L 651.3 250.8 L 646.1 250.8 L 641.8 256.7 L 639.8 262.7 L 640 263.7 L 640.2 264.7 L 640.4 265.8 L 641 266.5 L 641.8 267.1 L 642.7 267.7 L 643.6 268.3 L 644.5 268.9 L 645.3 269.5 L 646.2 270 L 647.1 270.6 L 648 271.2 L 648.8 271.8 L 649.9 271.7 L 650.9 271.6 L 652 271.5 L 653 271.4 L 654.1 271.3 L 655.1 271.2 L 656 271.3 L 656.7 272.1 L 657.4 272.9 L 658.1 273.7 L 658.7 274.5 L 659.4 275.4 L 660.1 276.2 L 660.7 277 L 661.4 277.8 L 662.1 278.6 L 662.8 279.4 L 663.7 279.9 L 664.6 280.4 L 665.5 280.8 L 666.5 281.3 L 667.4 281.8 L 668.4 282.3 L 669 283.1 L 669.6 284 L 669.5 284.7 L 668.7 285.4 L 667.9 286.1 L 667.1 286.8 L 666.2 287.4 L 665.4 288 L 664.4 288.2 L 663.3 288.5 L 662.4 288.4 L 661.4 288 L 660.4 287.5 L 659.5 287.1 L 658.5 286.7 L 657.6 286.3 L 656.6 285.8 L 655.8 286.5 L 655.1 287.3 L 654.5 287.8 L 654.5 286.7 L 654.5 284.6 L 652.6 284.4 L 650.8 288 L 648 289.6 L 646.2 290.6 L 646.1 292.6 L 646.1 296.8 L 640.4 299.2 L 638.5 303 L 637.7 303.1 L 632.8 301.2 L 632.5 300.2 L 632.2 299.2 L 631.4 296.2 L 631.6 294.1 L 631.7 293.1 L 632.1 289.9 L 635.6 284.4 L 634.9 277.1 L 631.8 271.8 L 628.7 271.1 L 626.9 267.5 L 624.2 266.4 L 623 263.5 L 625.8 257.8 Z",
      "position": {
        "x": 718.7,
        "y": 210.2
      },
      "badgeAnchor": {
        "x": 715.52,
        "y": 215.14
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-01",
      "name": "Aomori",
      "regionId": "tohoku",
      "adjacencies": [
        "jp-00",
        "jp-02",
        "jp-04"
      ],
      "shape": "M 613 358 L 613 351 L 609 347 L 616 339 L 621 339 L 628 335 L 630 319 L 627 314 L 630 313 L 631 306 L 637 311 L 641 308 L 645 310 L 647 325 L 650 332 L 656 329 L 655 325 L 657 321 L 668 329 L 671 327 L 675 311 L 671 304 L 665 310 L 651 313 L 657 287 L 674 299 L 683 294 L 680 325 L 683 339 L 687 350 L 691 349 L 696 354 L 690 361 L 685 360 L 681 362 L 679 360 L 665 370 L 662 368 L 663 357 L 658 358 L 658 352 L 647 359 L 644 357 L 642 359 L 635 354 L 632 357 L 619 356 L 617 359 Z",
      "position": {
        "x": 669.2,
        "y": 343.4
      },
      "badgeAnchor": {
        "x": 655.14,
        "y": 343.12
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-02",
      "name": "Iwate",
      "regionId": "tohoku",
      "adjacencies": [
        "jp-01",
        "jp-03",
        "jp-04"
      ],
      "shape": "M 698 447 L 691 446 L 689 459 L 682 457 L 679 462 L 672 457 L 674 454 L 667 454 L 656 449 L 658 443 L 655 438 L 657 435 L 649 422 L 653 411 L 657 406 L 655 401 L 658 397 L 655 392 L 659 392 L 658 373 L 662 368 L 665 370 L 679 360 L 681 362 L 685 360 L 690 361 L 696 354 L 703 366 L 702 370 L 706 373 L 704 378 L 711 383 L 713 397 L 711 408 L 715 403 L 715 408 L 717 410 L 712 415 L 713 417 L 717 414 L 716 418 L 713 418 L 712 422 L 710 423 L 714 422 L 709 425 L 711 428 L 709 429 L 713 429 L 707 436 L 711 438 L 706 438 L 709 441 L 706 441 L 708 443 L 702 444 L 702 441 L 703 445 L 701 445 L 701 449 L 700 445 Z",
      "position": {
        "x": 681.7,
        "y": 419.4
      },
      "badgeAnchor": {
        "x": 682.76,
        "y": 408.07
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-03",
      "name": "Miyagi",
      "regionId": "tohoku",
      "adjacencies": [
        "jp-02",
        "jp-04",
        "jp-05",
        "jp-06"
      ],
      "shape": "M 666 515 L 662 516 L 663 521 L 658 521 L 659 523 L 654 522 L 653 516 L 644 516 L 640 511 L 634 511 L 633 506 L 640 505 L 643 498 L 643 493 L 650 481 L 645 470 L 648 469 L 650 461 L 645 454 L 650 454 L 656 449 L 667 454 L 674 454 L 672 457 L 679 462 L 682 457 L 689 459 L 691 446 L 698 447 L 700 454 L 695 451 L 697 456 L 693 460 L 695 465 L 693 463 L 689 466 L 694 468 L 690 474 L 694 474 L 694 477 L 691 475 L 693 480 L 690 480 L 691 483 L 695 483 L 692 484 L 695 487 L 694 491 L 690 488 L 691 486 L 689 486 L 691 485 L 689 483 L 672 485 L 670 489 L 673 490 L 669 492 L 671 492 L 666 502 Z",
      "position": {
        "x": 664.1,
        "y": 471.4
      },
      "badgeAnchor": {
        "x": 661.32,
        "y": 474.72
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-04",
      "name": "Akita",
      "regionId": "tohoku",
      "adjacencies": [
        "jp-01",
        "jp-02",
        "jp-03",
        "jp-05"
      ],
      "shape": "M 656 449 L 650 454 L 645 454 L 641 452 L 639 448 L 626 444 L 621 439 L 612 440 L 614 431 L 619 422 L 620 399 L 613 392 L 605 394 L 602 386 L 608 388 L 614 380 L 618 372 L 618 364 L 613 358 L 617 359 L 619 356 L 632 357 L 635 354 L 642 359 L 644 357 L 647 359 L 658 352 L 658 358 L 663 357 L 662 368 L 658 373 L 659 392 L 655 392 L 658 397 L 655 401 L 657 406 L 653 411 L 649 422 L 657 435 L 655 438 L 658 443 Z",
      "position": {
        "x": 635.7,
        "y": 384.2
      },
      "badgeAnchor": {
        "x": 636.91,
        "y": 393.96
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-05",
      "name": "Yamagata",
      "regionId": "tohoku",
      "adjacencies": [
        "jp-03",
        "jp-04",
        "jp-06",
        "jp-14"
      ],
      "shape": "M 612 440 L 621 439 L 626 444 L 639 448 L 641 452 L 645 454 L 650 461 L 648 469 L 645 470 L 650 481 L 643 493 L 643 498 L 640 505 L 633 506 L 634 511 L 633 520 L 635 522 L 632 526 L 626 527 L 623 524 L 620 525 L 617 521 L 611 523 L 604 520 L 602 516 L 605 507 L 604 500 L 613 496 L 615 492 L 605 486 L 606 479 L 597 476 L 610 454 Z",
      "position": {
        "x": 624.6,
        "y": 470.4
      },
      "badgeAnchor": {
        "x": 628.78,
        "y": 473.71
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-06",
      "name": "Fukushima",
      "regionId": "tohoku",
      "adjacencies": [
        "jp-03",
        "jp-05",
        "jp-07",
        "jp-08",
        "jp-09",
        "jp-14"
      ],
      "shape": "M 661 580 L 651 575 L 651 580 L 645 585 L 635 577 L 634 571 L 628 566 L 616 563 L 591 579 L 583 577 L 584 563 L 579 559 L 583 552 L 581 548 L 582 545 L 591 545 L 592 541 L 600 541 L 598 533 L 607 522 L 604 520 L 611 523 L 617 521 L 620 525 L 623 524 L 626 527 L 632 526 L 635 522 L 633 520 L 634 511 L 640 511 L 644 516 L 653 516 L 654 522 L 659 523 L 658 521 L 663 521 L 662 516 L 666 515 L 672 530 L 672 556 L 670 573 Z",
      "position": {
        "x": 646.4,
        "y": 547.1
      },
      "badgeAnchor": {
        "x": 639.12,
        "y": 542.9
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-07",
      "name": "Ibaraki",
      "regionId": "kanto",
      "adjacencies": [
        "jp-06",
        "jp-08",
        "jp-10",
        "jp-11"
      ],
      "shape": "M 611 630 L 609 630 L 607 623 L 613 620 L 615 616 L 618 617 L 621 612 L 632 610 L 635 603 L 633 592 L 636 590 L 634 587 L 635 577 L 645 585 L 651 580 L 651 575 L 661 580 L 653 604 L 654 611 L 651 617 L 653 628 L 658 636 L 656 639 L 658 642 L 659 637 L 666 650 L 649 637 L 648 640 L 631 645 L 620 639 Z",
      "position": {
        "x": 633.4,
        "y": 626.8
      },
      "badgeAnchor": {
        "x": 637.73,
        "y": 625.39
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-08",
      "name": "Tochigi",
      "regionId": "kanto",
      "adjacencies": [
        "jp-06",
        "jp-07",
        "jp-09",
        "jp-10"
      ],
      "shape": "M 607 623 L 606 623 L 604 619 L 595 619 L 590 612 L 596 599 L 588 597 L 589 588 L 592 584 L 589 583 L 591 579 L 616 563 L 628 566 L 634 571 L 635 577 L 634 587 L 636 590 L 633 592 L 635 603 L 632 610 L 621 612 L 618 617 L 615 616 L 613 620 Z",
      "position": {
        "x": 613.4,
        "y": 588.4
      },
      "badgeAnchor": {
        "x": 612.75,
        "y": 588.31
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-09",
      "name": "Gunma",
      "regionId": "kanto",
      "adjacencies": [
        "jp-06",
        "jp-08",
        "jp-10",
        "jp-14",
        "jp-19"
      ],
      "shape": "M 606 623 L 595 624 L 590 620 L 579 618 L 574 628 L 558 637 L 554 635 L 554 629 L 551 626 L 554 626 L 552 619 L 555 617 L 554 611 L 545 611 L 542 606 L 543 599 L 548 595 L 547 593 L 556 590 L 568 584 L 568 581 L 571 580 L 570 575 L 574 574 L 576 570 L 583 577 L 591 579 L 589 583 L 592 584 L 589 588 L 588 597 L 596 599 L 590 612 L 595 619 L 604 619 Z",
      "position": {
        "x": 570.8,
        "y": 602.5
      },
      "badgeAnchor": {
        "x": 571,
        "y": 602.45
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-10",
      "name": "Saitama",
      "regionId": "kanto",
      "adjacencies": [
        "jp-07",
        "jp-08",
        "jp-09",
        "jp-11",
        "jp-18",
        "jp-19",
        "jp-13"
      ],
      "shape": "M 606 623 L 607 623 L 609 630 L 611 630 L 618 643 L 618 649 L 611 647 L 610 649 L 606 648 L 600 651 L 600 648 L 592 651 L 588 646 L 573 643 L 569 645 L 559 642 L 558 637 L 574 628 L 579 618 L 590 620 L 595 624 Z",
      "position": {
        "x": 585.6,
        "y": 632.8
      },
      "badgeAnchor": {
        "x": 585.19,
        "y": 632.95
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-11",
      "name": "Chiba",
      "regionId": "kanto",
      "adjacencies": [
        "jp-07",
        "jp-10",
        "jp-13"
      ],
      "shape": "M 617 658 L 619 654 L 618 649 L 618 643 L 611 630 L 620 639 L 631 645 L 648 640 L 649 637 L 666 650 L 667 653 L 657 654 L 646 664 L 643 686 L 630 690 L 619 704 L 612 700 L 617 698 L 614 696 L 616 693 L 615 687 L 617 683 L 613 678 L 616 674 L 619 675 L 619 671 L 625 669 L 630 662 L 623 655 L 618 659 Z",
      "position": {
        "x": 639.2,
        "y": 654.4
      },
      "badgeAnchor": {
        "x": 637.73,
        "y": 654.28
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-13",
      "name": "Kanagawa",
      "regionId": "kanto",
      "adjacencies": [
        "jp-10",
        "jp-11",
        "jp-18",
        "jp-21"
      ],
      "shape": "M 568 674 L 578 665 L 579 657 L 574 654 L 569 645 L 573 643 L 588 646 L 592 651 L 600 648 L 600 651 L 606 648 L 610 649 L 611 647 L 618 649 L 619 654 L 617 658 L 611 657 L 613 662 L 613 665 L 609 669 L 605 669 L 608 673 L 605 672 L 605 680 L 611 682 L 606 687 L 608 689 L 604 689 L 605 685 L 602 680 L 595 678 L 583 681 L 580 684 L 581 690 L 579 690 L 572 686 L 573 674 Z",
      "position": {
        "x": 589.23,
        "y": 663.01
      },
      "badgeAnchor": {
        "x": 589.23,
        "y": 663.01
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-14",
      "name": "Niigata",
      "regionId": "chubu",
      "adjacencies": [
        "jp-05",
        "jp-06",
        "jp-09",
        "jp-15",
        "jp-19"
      ],
      "shape": "M 510 589 L 507 578 L 503 575 L 517 570 L 526 563 L 533 563 L 548 551 L 558 536 L 563 523 L 582 510 L 583 513 L 582 511 L 589 505 L 597 476 L 606 479 L 605 486 L 615 492 L 613 496 L 604 500 L 605 507 L 602 516 L 604 520 L 607 522 L 598 533 L 600 541 L 592 541 L 591 545 L 582 545 L 581 548 L 583 552 L 579 559 L 584 563 L 583 577 L 576 570 L 574 574 L 570 575 L 571 580 L 568 581 L 568 584 L 556 590 L 556 583 L 551 579 L 551 575 L 548 572 L 541 574 L 536 580 L 536 584 L 532 582 L 524 587 L 522 585 L 522 580 L 515 579 L 515 582 Z",
      "position": {
        "x": 562.2,
        "y": 560.3
      },
      "badgeAnchor": {
        "x": 560.75,
        "y": 559.72
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-15",
      "name": "Toyama",
      "regionId": "chubu",
      "adjacencies": [
        "jp-14",
        "jp-16",
        "jp-19",
        "jp-20"
      ],
      "shape": "M 501 612 L 491 608 L 487 610 L 487 608 L 482 610 L 479 608 L 470 619 L 469 615 L 465 613 L 461 618 L 460 609 L 462 602 L 460 598 L 463 594 L 461 591 L 464 589 L 466 579 L 474 576 L 471 583 L 483 590 L 491 586 L 493 578 L 503 575 L 507 578 L 510 589 L 509 600 L 506 601 L 507 604 Z",
      "position": {
        "x": 488.67,
        "y": 597.95
      },
      "badgeAnchor": {
        "x": 488.67,
        "y": 597.95
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-16",
      "name": "Ishikawa",
      "regionId": "chubu",
      "adjacencies": [
        "jp-15",
        "jp-17",
        "jp-20"
      ],
      "shape": "M 461 618 L 464 621 L 459 631 L 454 632 L 449 627 L 439 626 L 433 617 L 447 603 L 459 585 L 460 574 L 458 570 L 458 565 L 455 564 L 460 551 L 485 541 L 489 542 L 490 546 L 484 547 L 483 556 L 479 555 L 472 562 L 470 559 L 467 560 L 465 569 L 471 571 L 474 567 L 474 576 L 466 579 L 464 589 L 461 591 L 463 594 L 460 598 L 462 602 L 460 609 Z",
      "position": {
        "x": 449.8,
        "y": 615.9
      },
      "badgeAnchor": {
        "x": 449.92,
        "y": 616.36
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-17",
      "name": "Fukui",
      "regionId": "chubu",
      "adjacencies": [
        "jp-16",
        "jp-20",
        "jp-24",
        "jp-25"
      ],
      "shape": "M 433 617 L 439 626 L 449 627 L 454 632 L 459 631 L 457 637 L 462 645 L 460 649 L 447 649 L 446 652 L 439 649 L 434 657 L 428 655 L 429 663 L 426 662 L 425 665 L 420 668 L 417 666 L 414 673 L 410 672 L 408 676 L 396 674 L 392 668 L 394 663 L 396 667 L 403 664 L 399 667 L 405 668 L 408 665 L 406 665 L 405 662 L 411 665 L 410 662 L 413 661 L 411 658 L 419 659 L 418 653 L 421 650 L 421 656 L 424 657 L 425 650 L 418 637 L 427 624 L 427 620 Z",
      "position": {
        "x": 439.5,
        "y": 639.41
      },
      "badgeAnchor": {
        "x": 439.5,
        "y": 639.41
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-18",
      "name": "Tokyo",
      "regionId": "kanto",
      "adjacencies": [
        "jp-10",
        "jp-13",
        "jp-19",
        "jp-21"
      ],
      "shape": "M 533 659 L 531 654 L 534 652 L 531 649 L 540 638 L 546 643 L 552 641 L 556 645 L 559 642 L 569 645 L 574 654 L 579 657 L 578 665 L 568 674 L 556 677 L 551 671 L 548 679 L 549 686 L 544 688 L 540 679 L 534 678 L 535 667 Z",
      "position": {
        "x": 560.1,
        "y": 659.4
      },
      "badgeAnchor": {
        "x": 560.25,
        "y": 661.7
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-19",
      "name": "Nagano",
      "regionId": "chubu",
      "adjacencies": [
        "jp-09",
        "jp-10",
        "jp-14",
        "jp-15",
        "jp-18",
        "jp-20",
        "jp-21",
        "jp-22"
      ],
      "shape": "M 556 590 L 547 593 L 548 595 L 543 599 L 542 606 L 545 611 L 554 611 L 555 617 L 552 619 L 554 626 L 551 626 L 554 629 L 554 635 L 558 637 L 559 642 L 556 645 L 552 641 L 546 643 L 540 638 L 531 649 L 534 652 L 531 654 L 533 659 L 529 664 L 529 676 L 513 686 L 505 684 L 500 687 L 499 681 L 501 678 L 500 674 L 503 674 L 501 671 L 503 667 L 497 661 L 499 658 L 494 651 L 487 648 L 490 643 L 495 643 L 501 636 L 502 632 L 499 628 L 504 618 L 501 612 L 507 604 L 506 601 L 509 600 L 510 589 L 515 582 L 515 579 L 522 580 L 522 585 L 524 587 L 532 582 L 536 584 L 536 580 L 541 574 L 548 572 L 551 575 L 551 579 L 556 583 Z",
      "position": {
        "x": 525.6,
        "y": 621.7
      },
      "badgeAnchor": {
        "x": 520.96,
        "y": 626.38
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-20",
      "name": "Gifu",
      "regionId": "chubu",
      "adjacencies": [
        "jp-15",
        "jp-16",
        "jp-17",
        "jp-19",
        "jp-22",
        "jp-23",
        "jp-24"
      ],
      "shape": "M 501 612 L 504 618 L 499 628 L 502 632 L 501 636 L 495 643 L 490 643 L 487 648 L 494 651 L 499 658 L 497 661 L 503 667 L 501 671 L 503 674 L 500 674 L 501 678 L 499 681 L 493 685 L 486 681 L 480 683 L 475 681 L 469 673 L 459 676 L 454 684 L 454 690 L 447 683 L 441 685 L 439 683 L 442 674 L 442 671 L 439 664 L 436 664 L 434 657 L 439 649 L 446 652 L 447 649 L 460 649 L 462 645 L 457 637 L 459 631 L 464 621 L 461 618 L 465 613 L 469 615 L 470 619 L 479 608 L 482 610 L 487 608 L 487 610 L 491 608 Z",
      "position": {
        "x": 474.1,
        "y": 657.6
      },
      "badgeAnchor": {
        "x": 474.47,
        "y": 657.97
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-21",
      "name": "Shizuoka",
      "regionId": "chubu",
      "adjacencies": [
        "jp-13",
        "jp-18",
        "jp-19",
        "jp-22"
      ],
      "shape": "M 568 674 L 573 674 L 572 686 L 579 690 L 576 695 L 581 701 L 580 705 L 573 715 L 573 720 L 565 724 L 560 718 L 562 704 L 561 701 L 562 697 L 568 696 L 557 690 L 550 693 L 547 697 L 548 700 L 540 704 L 537 713 L 532 720 L 533 724 L 520 720 L 495 719 L 495 711 L 503 706 L 513 686 L 529 676 L 529 664 L 533 659 L 535 667 L 534 678 L 540 679 L 544 688 L 549 686 L 548 679 L 551 671 L 556 677 Z",
      "position": {
        "x": 522.8,
        "y": 703.3
      },
      "badgeAnchor": {
        "x": 523.22,
        "y": 702.67
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-22",
      "name": "Aichi",
      "regionId": "chubu",
      "adjacencies": [
        "jp-19",
        "jp-20",
        "jp-21",
        "jp-23"
      ],
      "shape": "M 495 719 L 471 725 L 474 720 L 476 722 L 485 716 L 486 719 L 489 716 L 488 713 L 482 710 L 480 714 L 472 713 L 468 710 L 470 702 L 466 713 L 469 717 L 467 717 L 462 714 L 464 709 L 461 706 L 461 701 L 465 694 L 459 697 L 454 690 L 454 684 L 459 676 L 469 673 L 475 681 L 480 683 L 486 681 L 493 685 L 499 681 L 500 687 L 505 684 L 513 686 L 503 706 L 495 711 Z",
      "position": {
        "x": 484.5,
        "y": 696.3
      },
      "badgeAnchor": {
        "x": 484.42,
        "y": 696.56
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-23",
      "name": "Nara",
      "regionId": "kansai",
      "adjacencies": [
        "jp-20",
        "jp-22",
        "jp-24",
        "jp-25",
        "jp-28",
        "jp-29"
      ],
      "shape": "M 418 778 L 413 775 L 411 768 L 412 769 L 412 766 L 413 766 L 419 763 L 418 760 L 424 759 L 423 749 L 425 745 L 423 742 L 425 741 L 422 736 L 431 730 L 421 724 L 423 721 L 421 719 L 423 719 L 422 715 L 420 711 L 424 710 L 425 704 L 432 707 L 438 704 L 442 694 L 441 685 L 447 683 L 454 690 L 459 697 L 453 699 L 453 703 L 446 715 L 446 723 L 462 730 L 464 735 L 466 733 L 466 738 L 461 738 L 466 738 L 465 744 L 462 744 L 463 743 L 460 741 L 460 743 L 454 743 L 456 740 L 453 740 L 450 745 L 449 743 L 447 745 L 445 744 L 445 747 L 443 745 L 435 748 L 433 751 L 434 755 L 431 755 L 432 753 L 429 756 L 433 759 L 431 760 L 432 763 L 429 761 L 430 764 L 423 768 Z",
      "position": {
        "x": 434.4,
        "y": 718.3
      },
      "badgeAnchor": {
        "x": 434.2,
        "y": 717.14
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-24",
      "name": "Shiga",
      "regionId": "kansai",
      "adjacencies": [
        "jp-17",
        "jp-20",
        "jp-23",
        "jp-25"
      ],
      "shape": "M 434 657 L 436 664 L 439 664 L 442 671 L 442 674 L 439 683 L 441 685 L 442 694 L 438 704 L 432 707 L 425 704 L 424 710 L 420 711 L 416 705 L 412 705 L 410 695 L 412 680 L 408 676 L 410 672 L 414 673 L 417 666 L 420 668 L 425 665 L 426 662 L 429 663 L 428 655 Z",
      "position": {
        "x": 425.8,
        "y": 689.4
      },
      "badgeAnchor": {
        "x": 425.53,
        "y": 689.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-25",
      "name": "Kyoto",
      "regionId": "kansai",
      "adjacencies": [
        "jp-17",
        "jp-23",
        "jp-24",
        "jp-26",
        "jp-27",
        "jp-28"
      ],
      "shape": "M 405 712 L 403 704 L 399 702 L 399 700 L 396 703 L 387 695 L 388 689 L 379 687 L 377 681 L 372 682 L 365 677 L 365 671 L 371 672 L 371 665 L 371 663 L 365 665 L 362 660 L 363 656 L 365 659 L 364 656 L 381 649 L 385 656 L 377 662 L 379 664 L 382 660 L 381 664 L 386 665 L 385 669 L 387 667 L 389 668 L 386 663 L 393 660 L 394 663 L 392 668 L 396 674 L 408 676 L 412 680 L 410 695 L 412 705 L 416 705 L 420 711 L 422 715 L 420 716 L 415 713 L 411 716 Z",
      "position": {
        "x": 399.3,
        "y": 686.7
      },
      "badgeAnchor": {
        "x": 398.56,
        "y": 689.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-26",
      "name": "Osaka",
      "regionId": "kansai",
      "adjacencies": [
        "jp-25",
        "jp-27",
        "jp-28",
        "jp-29"
      ],
      "shape": "M 387 695 L 396 703 L 399 700 L 399 702 L 403 704 L 405 712 L 401 722 L 403 732 L 401 736 L 375 742 L 372 740 L 378 738 L 385 732 L 388 722 L 391 725 L 388 716 L 391 714 L 389 703 L 392 702 L 386 700 L 385 695 Z",
      "position": {
        "x": 395.52,
        "y": 716.8
      },
      "badgeAnchor": {
        "x": 393.44,
        "y": 717.06
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-27",
      "name": "Tottori",
      "regionId": "chugoku",
      "adjacencies": [
        "jp-25",
        "jp-26",
        "jp-30",
        "jp-32"
      ],
      "shape": "M 333 713 L 334 710 L 330 705 L 332 702 L 330 695 L 338 686 L 338 681 L 344 679 L 344 674 L 337 657 L 346 654 L 363 656 L 362 660 L 365 665 L 371 663 L 371 665 L 371 672 L 365 671 L 365 677 L 372 682 L 377 681 L 379 687 L 388 689 L 387 695 L 385 695 L 386 700 L 392 702 L 389 703 L 391 714 L 388 716 L 383 715 L 370 720 L 355 711 L 341 711 L 340 708 L 338 713 L 335 711 Z",
      "position": {
        "x": 355.6,
        "y": 692.8
      },
      "badgeAnchor": {
        "x": 356.16,
        "y": 689.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-28",
      "name": "Wakayama",
      "regionId": "kansai",
      "adjacencies": [
        "jp-23",
        "jp-25",
        "jp-26",
        "jp-29"
      ],
      "shape": "M 414 762 L 413 766 L 412 766 L 412 769 L 411 768 L 397 766 L 399 761 L 395 754 L 400 747 L 404 746 L 401 736 L 403 732 L 401 722 L 405 712 L 411 716 L 415 713 L 420 716 L 422 715 L 423 719 L 421 719 L 423 721 L 421 724 L 431 730 L 422 736 L 425 741 L 423 742 L 425 745 L 423 749 L 424 759 L 418 760 Z",
      "position": {
        "x": 413.3,
        "y": 741.3
      },
      "badgeAnchor": {
        "x": 413.56,
        "y": 730.7
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-29",
      "name": "Tokushima",
      "regionId": "kansai",
      "adjacencies": [
        "jp-23",
        "jp-26",
        "jp-28",
        "jp-35"
      ],
      "shape": "M 411 768 L 413 775 L 418 778 L 414 783 L 416 787 L 407 792 L 406 795 L 405 795 L 405 793 L 389 788 L 383 780 L 387 777 L 378 773 L 373 767 L 369 767 L 372 762 L 370 761 L 375 758 L 371 755 L 374 753 L 373 751 L 378 750 L 370 743 L 372 740 L 375 742 L 401 736 L 404 746 L 400 747 L 395 754 L 399 761 L 397 766 Z",
      "position": {
        "x": 400.7,
        "y": 778.8
      },
      "badgeAnchor": {
        "x": 387.13,
        "y": 760.21
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-30",
      "name": "Hyogo",
      "regionId": "chugoku",
      "adjacencies": [
        "jp-27",
        "jp-31",
        "jp-32",
        "jp-33"
      ],
      "shape": "M 280 690 L 273 688 L 276 683 L 274 679 L 282 677 L 283 668 L 277 660 L 280 659 L 282 663 L 288 665 L 296 661 L 307 663 L 328 662 L 337 657 L 344 674 L 344 679 L 338 681 L 326 685 L 325 678 L 318 676 L 319 673 L 309 679 L 305 675 L 297 673 L 295 679 L 292 680 L 293 683 L 287 682 L 287 686 L 281 687 Z",
      "position": {
        "x": 332,
        "y": 671.4
      },
      "badgeAnchor": {
        "x": 312.26,
        "y": 667.57
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-31",
      "name": "Okayama",
      "regionId": "chugoku",
      "adjacencies": [
        "jp-30",
        "jp-33",
        "jp-34"
      ],
      "shape": "M 198 709 L 206 707 L 220 693 L 231 687 L 237 679 L 248 674 L 250 668 L 248 665 L 266 660 L 272 655 L 275 658 L 283 658 L 280 659 L 277 660 L 283 668 L 282 677 L 274 679 L 276 683 L 273 688 L 260 686 L 253 695 L 247 698 L 250 702 L 242 704 L 236 702 L 234 705 L 226 703 L 220 708 L 222 710 L 220 716 L 215 721 L 216 723 L 213 725 L 213 729 L 210 733 L 208 731 L 203 733 L 200 729 L 202 724 L 197 724 L 196 720 L 199 715 Z",
      "position": {
        "x": 262.4,
        "y": 673.9
      },
      "badgeAnchor": {
        "x": 237.5,
        "y": 690.3
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-32",
      "name": "Shimane",
      "regionId": "chugoku",
      "adjacencies": [
        "jp-27",
        "jp-30",
        "jp-33",
        "jp-36"
      ],
      "shape": "M 338 681 L 338 686 L 330 695 L 332 702 L 330 705 L 334 710 L 333 713 L 326 712 L 329 714 L 322 721 L 313 720 L 318 722 L 316 726 L 314 725 L 312 729 L 307 727 L 305 730 L 302 724 L 302 728 L 299 723 L 295 727 L 289 724 L 291 728 L 287 726 L 283 710 L 285 706 L 281 700 L 282 693 L 280 690 L 281 687 L 287 686 L 287 682 L 293 683 L 292 680 L 295 679 L 297 673 L 305 675 L 309 679 L 319 673 L 318 676 L 325 678 L 326 685 Z",
      "position": {
        "x": 305.9,
        "y": 699.9
      },
      "badgeAnchor": {
        "x": 319.04,
        "y": 700.61
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-33",
      "name": "Hiroshima",
      "regionId": "chugoku",
      "adjacencies": [
        "jp-30",
        "jp-31",
        "jp-32",
        "jp-34",
        "jp-37"
      ],
      "shape": "M 287 726 L 287 728 L 284 726 L 287 729 L 285 729 L 283 733 L 277 731 L 277 728 L 268 730 L 266 735 L 253 735 L 251 739 L 245 742 L 243 740 L 240 742 L 241 739 L 238 733 L 239 731 L 231 731 L 224 737 L 225 740 L 219 738 L 219 732 L 216 730 L 216 723 L 215 721 L 220 716 L 222 710 L 220 708 L 226 703 L 234 705 L 236 702 L 242 704 L 250 702 L 247 698 L 253 695 L 260 686 L 273 688 L 280 690 L 282 693 L 281 700 L 285 706 L 283 710 Z",
      "position": {
        "x": 265.1,
        "y": 711.4
      },
      "badgeAnchor": {
        "x": 256.09,
        "y": 714.78
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-34",
      "name": "Yamaguchi",
      "regionId": "chugoku",
      "adjacencies": [
        "jp-31",
        "jp-33",
        "jp-39"
      ],
      "shape": "M 198 709 L 199 715 L 196 720 L 197 724 L 202 724 L 200 729 L 203 733 L 208 731 L 210 733 L 213 729 L 213 725 L 216 723 L 216 730 L 219 732 L 219 738 L 225 740 L 224 745 L 222 745 L 222 753 L 217 756 L 218 763 L 214 757 L 209 757 L 204 751 L 200 753 L 202 750 L 198 747 L 188 751 L 184 748 L 182 751 L 182 749 L 180 751 L 180 747 L 178 752 L 173 754 L 171 752 L 169 754 L 167 749 L 162 745 L 155 752 L 155 745 L 153 741 L 157 735 L 154 730 L 156 726 L 163 726 L 158 724 L 160 721 L 168 723 L 169 726 L 177 726 L 183 724 L 182 721 L 193 710 L 196 711 Z",
      "position": {
        "x": 189,
        "y": 735.9
      },
      "badgeAnchor": {
        "x": 190.13,
        "y": 736.84
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-35",
      "name": "Kagawa",
      "regionId": "shikoku",
      "adjacencies": [
        "jp-29",
        "jp-36",
        "jp-37",
        "jp-38"
      ],
      "shape": "M 338 745 L 345 744 L 345 746 L 348 747 L 344 756 L 351 763 L 347 768 L 353 769 L 334 780 L 329 786 L 324 785 L 321 781 L 323 778 L 317 777 L 316 768 L 310 770 L 297 764 L 298 756 L 308 751 L 314 753 L 324 747 L 336 749 Z",
      "position": {
        "x": 330.7,
        "y": 764
      },
      "badgeAnchor": {
        "x": 325.32,
        "y": 762.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-36",
      "name": "Kochi",
      "regionId": "shikoku",
      "adjacencies": [
        "jp-32",
        "jp-35",
        "jp-37"
      ],
      "shape": "M 298 756 L 294 754 L 297 745 L 292 740 L 298 743 L 312 733 L 319 736 L 323 733 L 324 737 L 326 735 L 329 737 L 329 740 L 338 745 L 336 749 L 324 747 L 314 753 L 308 751 Z",
      "position": {
        "x": 313.6,
        "y": 743.1
      },
      "badgeAnchor": {
        "x": 312.84,
        "y": 743.42
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-37",
      "name": "Fukuoka",
      "regionId": "shikoku",
      "adjacencies": [
        "jp-33",
        "jp-35",
        "jp-36",
        "jp-38",
        "jp-43"
      ],
      "shape": "M 242 821 L 234 819 L 235 822 L 232 822 L 233 817 L 237 818 L 231 813 L 233 812 L 231 808 L 235 808 L 231 807 L 233 805 L 230 803 L 234 806 L 238 802 L 237 799 L 234 799 L 236 796 L 228 796 L 231 794 L 229 792 L 231 787 L 225 786 L 217 792 L 210 793 L 244 773 L 251 755 L 259 751 L 258 747 L 260 746 L 269 760 L 279 756 L 289 758 L 294 754 L 298 756 L 297 764 L 272 768 L 266 777 L 262 787 L 251 788 L 256 797 L 250 800 L 245 808 L 241 805 L 244 818 Z",
      "position": {
        "x": 259.1,
        "y": 766.4
      },
      "badgeAnchor": {
        "x": 249.75,
        "y": 778.55
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-38",
      "name": "Ehime",
      "regionId": "shikoku",
      "adjacencies": [
        "jp-35",
        "jp-37"
      ],
      "shape": "M 297 764 L 310 770 L 316 768 L 317 777 L 323 778 L 321 781 L 324 785 L 329 786 L 322 805 L 310 789 L 300 786 L 291 788 L 290 785 L 291 788 L 279 792 L 285 792 L 279 793 L 278 796 L 276 793 L 273 798 L 274 802 L 272 808 L 269 808 L 265 816 L 260 817 L 260 825 L 257 828 L 260 835 L 256 830 L 249 833 L 244 829 L 240 831 L 242 825 L 245 824 L 245 821 L 242 821 L 244 818 L 241 805 L 245 808 L 250 800 L 256 797 L 251 788 L 262 787 L 266 777 L 272 768 Z",
      "position": {
        "x": 279.1,
        "y": 779.2
      },
      "badgeAnchor": {
        "x": 280.33,
        "y": 778.42
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-39",
      "name": "Nagasaki",
      "regionId": "kyushu",
      "adjacencies": [
        "jp-34",
        "jp-40",
        "jp-42",
        "jp-43"
      ],
      "shape": "M 148 804 L 140 799 L 138 803 L 134 802 L 130 806 L 130 809 L 125 808 L 125 803 L 123 800 L 124 793 L 133 788 L 133 782 L 127 784 L 120 778 L 108 778 L 114 774 L 111 771 L 117 766 L 120 772 L 127 771 L 129 766 L 125 768 L 122 765 L 127 766 L 131 763 L 132 755 L 142 754 L 143 751 L 149 752 L 146 755 L 149 756 L 150 753 L 154 755 L 161 751 L 157 759 L 159 761 L 158 762 L 163 772 L 168 773 L 167 780 L 159 779 L 152 783 L 148 789 L 150 794 L 148 795 L 151 799 Z",
      "position": {
        "x": 144,
        "y": 770.4
      },
      "badgeAnchor": {
        "x": 144.56,
        "y": 770.03
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-40",
      "name": "Miyazaki",
      "regionId": "kyushu",
      "adjacencies": [
        "jp-39"
      ],
      "shape": "M 108 778 L 120 778 L 127 784 L 133 782 L 133 788 L 124 793 L 123 800 L 117 795 L 112 800 L 114 810 L 107 808 L 100 801 L 101 796 L 95 794 L 92 788 L 94 785 L 98 789 L 96 785 L 99 781 L 94 778 L 96 776 L 98 778 L 98 772 L 99 774 L 104 774 L 104 778 Z",
      "position": {
        "x": 113.06,
        "y": 786.71
      },
      "badgeAnchor": {
        "x": 113.06,
        "y": 786.71
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-42",
      "name": "Saga",
      "regionId": "kyushu",
      "adjacencies": [
        "jp-39",
        "jp-43",
        "jp-44",
        "jp-45"
      ],
      "shape": "M 137 866 L 132 860 L 123 864 L 119 860 L 131 844 L 129 839 L 131 840 L 130 838 L 136 832 L 126 833 L 134 827 L 135 822 L 126 814 L 125 808 L 130 809 L 130 806 L 134 802 L 138 803 L 140 799 L 148 804 L 155 809 L 157 805 L 156 799 L 162 800 L 169 813 L 169 819 L 172 822 L 169 823 L 160 837 L 155 839 L 154 846 L 159 853 L 155 858 L 158 863 Z",
      "position": {
        "x": 150.3,
        "y": 823.4
      },
      "badgeAnchor": {
        "x": 145.72,
        "y": 828.84
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-43",
      "name": "Oita",
      "regionId": "kyushu",
      "adjacencies": [
        "jp-37",
        "jp-39",
        "jp-42",
        "jp-44"
      ],
      "shape": "M 148 804 L 151 799 L 148 795 L 150 794 L 148 789 L 152 783 L 159 779 L 167 780 L 168 773 L 180 777 L 185 770 L 194 774 L 196 780 L 194 788 L 190 787 L 191 790 L 183 792 L 183 796 L 187 798 L 204 797 L 198 806 L 203 806 L 200 808 L 203 810 L 208 808 L 209 811 L 204 811 L 202 815 L 212 819 L 206 819 L 208 821 L 204 824 L 208 825 L 201 826 L 201 830 L 199 830 L 200 825 L 195 824 L 192 828 L 184 828 L 180 823 L 174 824 L 172 822 L 169 819 L 169 813 L 162 800 L 156 799 L 157 805 L 155 809 Z",
      "position": {
        "x": 186.6,
        "y": 811.5
      },
      "badgeAnchor": {
        "x": 173.82,
        "y": 798.36
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-44",
      "name": "Kagoshima",
      "regionId": "kyushu",
      "adjacencies": [
        "jp-42",
        "jp-43",
        "jp-45"
      ],
      "shape": "M 172 822 L 174 824 L 180 823 L 184 828 L 192 828 L 195 824 L 200 825 L 199 830 L 201 830 L 190 840 L 189 844 L 192 845 L 188 846 L 187 848 L 189 849 L 184 857 L 178 874 L 175 897 L 170 902 L 168 914 L 163 912 L 158 907 L 160 904 L 160 897 L 153 896 L 150 887 L 145 885 L 147 880 L 141 875 L 136 868 L 137 866 L 158 863 L 155 858 L 159 853 L 154 846 L 155 839 L 160 837 L 169 823 Z",
      "position": {
        "x": 162,
        "y": 878.1
      },
      "badgeAnchor": {
        "x": 169.93,
        "y": 853.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jp-45",
      "name": "Kumamoto",
      "regionId": "kyushu",
      "adjacencies": [
        "jp-42",
        "jp-44"
      ],
      "shape": "M 119 860 L 123 864 L 132 860 L 137 866 L 136 868 L 141 875 L 147 880 L 145 885 L 150 887 L 153 896 L 160 897 L 160 904 L 158 907 L 155 906 L 150 912 L 155 915 L 153 918 L 156 918 L 150 921 L 146 926 L 130 934 L 130 929 L 135 926 L 139 913 L 134 905 L 134 899 L 128 897 L 133 895 L 134 899 L 137 899 L 141 893 L 134 888 L 130 890 L 124 903 L 126 914 L 131 917 L 129 922 L 123 923 L 120 917 L 107 916 L 108 913 L 105 911 L 107 910 L 102 905 L 111 906 L 115 895 L 112 887 L 107 882 L 110 875 L 108 864 L 112 862 L 115 864 Z",
      "position": {
        "x": 123.4,
        "y": 877.7
      },
      "badgeAnchor": {
        "x": 124.66,
        "y": 877.34
      },
      "ownerId": "",
      "armies": 0
    }
  ],
  "geometryVersion": "v1-720b5741-c1594bc4",
  "seaRoutes": [
    {
      "aId": "jp-29",
      "bId": "jp-35",
      "from": {
        "x": 369,
        "y": 767
      },
      "to": {
        "x": 353,
        "y": 769
      }
    },
    {
      "aId": "jp-32",
      "bId": "jp-36",
      "from": {
        "x": 312,
        "y": 729
      },
      "to": {
        "x": 312,
        "y": 733
      }
    },
    {
      "aId": "jp-33",
      "bId": "jp-37",
      "from": {
        "x": 251,
        "y": 739
      },
      "to": {
        "x": 258,
        "y": 747
      }
    },
    {
      "aId": "jp-34",
      "bId": "jp-39",
      "from": {
        "x": 155,
        "y": 752
      },
      "to": {
        "x": 154,
        "y": 755
      }
    },
    {
      "aId": "jp-37",
      "bId": "jp-43",
      "from": {
        "x": 210,
        "y": 793
      },
      "to": {
        "x": 204,
        "y": 797
      }
    }
  ]
}
